export const podsjetnik_placanje = {
    templateId: 51.1,
    category: 6,
    templateTitle: "Podsjetnik na plaćanje",
    templateDescription: `<p>Neformalniji oblik dopisa koji služi kao podsjetnik dužniku na plaćanje.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>U određenim slučajevima, kada dužnik ne postupa prema pozivima vjerovnika za plaćanje dospjelih nepodmirenih obveza, a vjerovnik ne želi posegnuti za formalnijim dopisima (opomena pred tužbu i sl.) koji bi mogli negativno utjecati na poslovni odnos, poslovno je oportuno uputiti podsjetnik na plaćanje prema primjeru dolje.</p>

  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
   
   title: 'Podsjetnik na plaćanje',
   noArticleNumbers: true,
   noArticleTitle: true,

   articles: [
               {
                   title: '',
                   mandatory: true,
                   dummy: true,
                   exampleContent: true,
                   statements: [
                       {
                           type: 'text',
                           mandatory: true,
                           editable: true,
                           content: 'Poštovani,\r\n\r\nuvidom u naše poslovne knjige utvrdili smo da imate nepodmirenih dospjelih obveza prema nama u iznosu od ______. \r\nOvim putem Vas u duhu dobre poslovne suradnje podsjećamo na spomenute financijske obveze prema nama te Vas ovim putem pozivamo da iste podmirite u što kraćem roku. \r\n\r\nS poštovanjem.',
                           value: '',
                       }],
               },
               {
                mandatory: true,
                static: true,
                type: 2, // date and place
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      {
                        type: "text",
                        content: "U"
                      },
                      {
                        type: "input",
                        value: "",
                        placeholder: "Upišite mjesto.",
                        required: true,
                      },
                      {
                        type: "text",
                        content: ", dana"
                      },
                      {
                        type: "date",
                        value: new Date(),
                        required: true
                      },
                      {
                        type: "text",
                        content: "godine."
                      }
                    ]
                  },
                ]
              },
               {
                   mandatory: true,
                   static: true,
                   type: 3,  // signatures
                   statements: [],
               },
           ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/51.1_podsjetnik_placanje.ts